<button class="btn btn-primary float-left" type="button" (click)="openAddTemplate(addTemplateModal);"><i class="fa fa-plus"></i> Add Audit Template To Company</button>

<ng-template #addTemplateModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Add Audit Template To Company</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>


    <div class="modal-body">
        <form [formGroup]="addAuditTemplateForm">
            <error-message [errors]="errors"></error-message>
            <div class="container">

                <div class="row form-group">
                    <div class="col-12">
                        <label class="control-label text-info">Audit Template</label>
                        <div>
                            <select class="js-example-basic-single form-control" name="auditTemplateId" formControlName="auditTemplateId" placeholder="Select an Audit Template">
                                <option *ngFor="let a of auditTemplates" [value]="a.id">{{ a.description }}</option>
                            </select>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>

    <div class="modal-footer">
        <div class="row">
            <div class="col-md-12 text-right">
                <button type="button" class="btn btn-danger modal-dismiss me-2" (click)="modal.close('Close');">Cancel</button>
                <button type="button" class="btn btn-success" (click)="addAuditTemplateToCompany();" [disabled]="submitAttempt||!addAuditTemplateForm.valid">Add Audit Template</button>
            </div>
        </div>
    </div>

</ng-template>
